import { render, staticRenderFns } from "./SignupConfirm.vue?vue&type=template&id=4c54a7fd"
import script from "./SignupConfirm.vue?vue&type=script&lang=js"
export * from "./SignupConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports